const Group = ({ items }) => (
  <div className="marquee-group">
    {items.map((it, i) => (
      <span className="marquee-item" key={i}>
        <i className="diamond" aria-hidden="true" />
        {it}
      </span>
    ))}
  </div>
);

const Marquee = ({ items }) => (
  <div className="marquee" data-testid="marquee-strip" aria-label={items.join(" · ")}>
    <div className="marquee-track">
      <Group items={items} />
      <div className="marquee-group" aria-hidden="true">
        {items.map((it, i) => (
          <span className="marquee-item" key={i}>
            <i className="diamond" aria-hidden="true" />
            {it}
          </span>
        ))}
      </div>
    </div>
  </div>
);

export default Marquee;
